export enum LicenseType {
  Basic = 'USER_ADMINISTRATION.LICENSE.BASIC',
  ConstructionAdministration = 'USER_ADMINISTRATION.LICENSE.CONSTRUCTION_ADMINISTRATION',
  MultipleLicenses = 'USER_ADMINISTRATION.LICENSE.MULTIPLE_LICENSES',
  NotSupported = '-'
}
